/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
import './device_code';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "ResetDeviceCodeRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ResetDeviceCodeResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceCode": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.ResetDeviceCodeRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.ResetDeviceCodeResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ResetDeviceCodeRequest @ squareup/devicesettings/external/device_code_reset.proto at 14:1
 */
export const ResetDeviceCodeRequest = $root.lookupType('squareup.devicesettings.external.ResetDeviceCodeRequest');
fixType(ResetDeviceCodeRequest);
Builder.createAndAttachToType(ResetDeviceCodeRequest);
/**
 * SOURCE ResetDeviceCodeResponse @ squareup/devicesettings/external/device_code_reset.proto at 21:1
 */
export const ResetDeviceCodeResponse = $root.lookupType('squareup.devicesettings.external.ResetDeviceCodeResponse');
fixType(ResetDeviceCodeResponse);
Builder.createAndAttachToType(ResetDeviceCodeResponse);